module.exports = __webpack_public_path__ + "img/logo.139556b9.svg";